export default __webpack_public_path__ + "static/media/user-boxes.4b621a76.svg";